'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAction;

var _isFunction = require('./isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createAction(type, actionCreator, metaCreator) {
  return function () {
    var action = { type: type };
    if ((0, _isFunction2.default)(actionCreator)) {
      action.payload = actionCreator.apply(undefined, arguments);
    }
    if ((0, _isFunction2.default)(metaCreator)) {
      action.meta = metaCreator.apply(undefined, arguments);
    }
    return action;
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/flux-actions/static-1.35/js/createAction.js
// module id = 319
// module chunks = 0